import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  if (!environment.useAuthInterceptor) {
    return next(req);
  }
  const cloned = req.clone({
    setHeaders: {
      'x-forwarded-user': environment.username,
      'x-forwarded-groups': environment.userrole,
      'x-forwarded-admin-permissions': '["USER_READ"]',
    },
  });
  return next(cloned);
};
